import dayjs from "dayjs";
import React, { useState } from "react";
import { makeAppointment } from "../functions/appointments";

const width = window.innerWidth
const height = window.innerHeight

const styles = {
    symptomsWrapper: {
        position: "absolute",
        bottom: 0,
        width,
        height: "fit-content",
        backgroundColor: "#141414",
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        padding: "10px 0"
    },
    barView: {
        opacity: 0.5,
        backgroundColor: "red",
        width: 100,
        padding: "8px 0",
        borderRadius: 50,
        display: "flex",
        alignSelf: "center",
        margin: "10px 0"
    },
    formTitle: {
        margin: 15,
        fontSize: 18,
        fontWeight: "bold",
        color: "#FFF"
    },
    chipWrapper: {
        height: 45,
        margin: 5,
        padding: "0px 20px",
        borderRadius: 50,
        borderWidth: 1,
        borderColor: "red",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    titles: {
        margin: 16,
        fontSize: 16,
        color: "#FFF"
    },
    buttonWrapper: {
        height: 50,
        width: width - 20,
        borderRadius: 50,
        backgroundColor: "red",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 10,
        marginTop: 5
    },
    buttonText: {
        color: "white",
        fontSize: 16,
        fontWeight: "bold"
    },
    counters: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    counterSelector: { 
        margin: "0 5px", 
        display: "flex",
        flexDirection: "row", 
        alignItems: "center",
        marginLeft: 10
    },
    controller: {
        backgroundColor: "red",
        borderRadius: 15,
    },
    blocker: {
        position: "absolute",
        width,
        height,
        backgroundColor: "rgba(0,0,0,0.4)",
        top: 0
    },
    datePicker: {
        height: 45,
        margin: "0 10px",
        borderRadius: 50,
        borderWidth: 1,
        borderColor: "red",
        padding: "0 20px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    addMoreButton: {
        display: "flex",
        backgroundColor: "red",
        justifyContent: "center",
        alignItems: "center",
        width: 45,
        height: 45,
        borderRadius: 50,
        margin: "0 10px"
    },
    inputText: {
        margin: "0 10px",
        backgroundColor: "rgb(250,250,250)",
        borderRadius: 10,
        height: 45,
        padding: "0 15px",
        fontSize: 16,
        width: width - 50,
        color: "#000",
        outline: "none",
        border: "none"
    },
    loaderWrapper: {
        width,
        height,
        position: "absolute",
        top: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: 'center',
        alignItems: "center"
    }
}

export default function SymptomForm({ appointment, setAppointment, setDate }) {

    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState(null)

    const [appointmentInfo, setAppointmentInfo] = useState({
        symptoms: [],
        DOA: new Date(),
        appointmentFor: "Myself",
    })

    const [otherUser, setOtherUser] = useState({
        names: "",
        age: ""
    })

    async function makingAppointment() {
        setLoading(true)
        const result = await makeAppointment(appointmentInfo, otherUser)
        setErrors(result)

        setOtherUser({
            names: "",
            age: ""
        })
 
        setAppointmentInfo({
            symptoms: [],
            DOA: new Date(),
            appointmentFor: "Myself",
        })

        setAppointment(null)
        setLoading(false)
    }

    function setDateData(e) {

        setAppointmentInfo({
            ...appointmentInfo,
            DOA: e,
        })
        setDate(dayjs(e).format("YYYY-MM-DD"))

    }

 
    return (
        <>
            {appointment && <div onClick={() => { setAppointment(false)}} style={styles.blocker} />}
        <>
            <div style={{ ...styles.symptomsWrapper, bottom: appointment ? 50 : -height, transition: "all ease 300ms" }}> 
                <div >
                    <div >
                    <p style={styles.titles}>Your Information</p>
                    <input 
                        onChange={
                            ({ target: { value: e }}) => setAppointmentInfo({ ...appointmentInfo, condition: e})
                        } 
                        value={appointmentInfo.condition}
                        style={{ ...styles.inputText, margin: "7px 10px" }} 
                        placeholder="Condition"
                    />
                    <input 
                        onChange={
                            ({ target: { value: e }}) => setAppointmentInfo({ ...appointmentInfo, payment: e})
                        } 
                        value={appointmentInfo.payment}
                        style={{ ...styles.inputText, margin: "7px 10px" }} 
                        placeholder="Cash Or Medical"
                    />
                    <p style={styles.titles}>Day Of Appointment</p>
                    <input
                        type="date"
                        label={dayjs(appointmentInfo.DOA).format("DD MMMM YYYY")}
                        value={appointmentInfo.DOA}
                        onChange={e => setDateData(e.target.value)}
                        style={styles.inputText}
                    />

                    <p style={styles.titles}>Who Is This Appointment For?</p>
                    <SymptomList 
                        active={appointmentInfo.appointmentFor} 
                        setActive={(e) => {
                            setAppointmentInfo({
                                ...appointmentInfo,
                                appointmentFor: e
                            })
                        }} 
                        data={["Myself", "Other"]} 
                    />
                    {appointmentInfo.appointmentFor === "Other" && (
                        <>
                            <input onChange={({ target: { value: e }}) => setOtherUser({ ...otherUser, names: e})} style={{ ...styles.inputText, margin: "7px 10px" }} placeholder="Other Person's Name" />
                            <input onChange={({ target: { value: e }}) => setOtherUser({ ...otherUser, age: e})}  keyboardType="numeric" style={{ ...styles.inputText, margin: "7px 10px" }} placeholder="Other Person's Age" />
                        </>
                    )}
                    <p style={styles.titles}>Do You Have Any Questions?</p>
                    <input 
                        onChange={
                            ({ target: { value: e }}) => setAppointmentInfo({ ...appointmentInfo, questions: e})
                        } 
                        value={appointmentInfo.questions}
                        style={{ ...styles.inputText, margin: "7px 10px" }} 
                        placeholder="Cash Or Medical"
                    />
                    <div onClick={makingAppointment} style={{ ...styles.buttonWrapper, marginTop: 20 }}>
                        <p style={styles.buttonText}>Continue</p>
                    </div>
                    </div>
                </div>
            </div>
        </>
        {loading && (
            <div style={styles.loaderWrapper}>
                {/* <ActivityIndicator size="large" color="white" /> */}
                <p>loading...</p>
            </div>
        )}
        </>
    )
}

function FlatList({ data, keyExtractor, renderItem: Component }) {
    return (
        <div style={{ display: "flex", flexDirection: "row" }}>
            {data.map(item => <Component key={keyExtractor(item)} item={item} />)}
        </div>
    )
}

function SymptomList({data, active, setActive}) {

    return (
        <FlatList
            data={data}
            horizontal
            showsHorizontalScrollIndicator={false}
            keyExtractor={item => item}
            renderItem={({item}) => (
                <div onClick={setActive.bind("click", item)} 
                    style={{ ...styles.chipWrapper, backgroundColor: active === item ? "red" : "white" }}
                >
                    <p style={{ fontSize: 16, color: active === item ? "white" : "#141414"}}>
                        {item}
                    </p>
                </div>
            )}
        />
    )
}
